import { useEffect, useState } from 'react';

/*
 * useMediaQuery — subscribe to a CSS media query and re-render on change.
 * Returns whether the query currently matches. SSR-safe (defaults to false when
 * there's no window).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener?.('change', onChange);
    return () => mql.removeEventListener?.('change', onChange);
  }, [query]);

  return matches;
}

export default useMediaQuery;
